module.exports = __webpack_public_path__ + "static/media/background-unsplashed-3.4bd2e7b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/background-unsplashed-3.jpg
// module id = 274
// module chunks = 1